module.exports = __webpack_public_path__ + "static/media/battery-image-01.39dcbcc4.png";